import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Angebotsdetails',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Mindestbestellwert und %-Rabatt festlegen',
      qualifying_criteria: {
        title: 'Mindestbestellwert',
        description: 'Legen Sie den erforderlichen Bestellwert fest.',
      },
      details: {
        title: '%-Rabatt',
        description: 'Legen Sie den Rabatt fest, den Kundinnen und Kunden auf ihre Bestellung erhalten.',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Rabattfaehige Artikel und %-Rabatt festlegen',
      qualifying_criteria: {
        title: 'Rabattierte Artikel',
        description: 'Waehlen Sie die Artikel aus, fuer die Sie einen Rabatt anbieten.',
      },
      details: {
        title: '%-Rabatt',
        description: 'Legen Sie den Rabatt fest, den Kundinnen und Kunden auf ihre Bestellung erhalten.',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Rabattfaehige Artikel und {{currency}}-Rabatt festlegen',
      qualifying_criteria: {
        title: 'Rabattierte Artikel',
        description: 'Waehlen Sie die Artikel aus, fuer die Sie einen Rabatt anbieten.',
      },
      details: {
        title: '{{currency}}-Rabatt',
        description: 'Legen Sie den Rabatt fest, den Kundinnen und Kunden auf ihre Bestellung erhalten.',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Mindestbestellwert und {{currency}}-Rabatt festlegen',
      qualifying_criteria: {
        title: 'Mindestbestellwert',
        description: 'Legen Sie den erforderlichen Bestellwert fest.',
      },
      details: {
        title: '{{currency}}-Rabatt',
        description: 'Legen Sie den Rabatt fest, den Kundinnen und Kunden auf ihre Bestellung erhalten.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Mindestbestellwert und Gratisartikel festlegen',
      qualifying_criteria: {
        title: 'Mindestbestellwert',
        description:
          'Legen Sie den Betrag fest, den Kundinnen und Kunden ausgeben muessen, um den Gratisartikel zu erhalten.',
      },
      details: {
        title: 'Gratisartikel:',
        description:
          'Waehlen Sie den Gratisartikel (oder mehrere), aus denen Kundinnen und Kunden einen auswaehlen koennen.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Angebotsbedingungen festlegen',
      qualifying_criteria: {
        title: 'Aktionsartikel',
        description:
          'Waehlen Sie die Artikel aus, die Kundinnen und Kunden bestellen muessen, um den Gratisartikel zu erhalten.',
      },
      details: {
        title: 'Gratisartikel:',
        description:
          'Waehlen Sie den Gratisartikel (oder mehrere), aus denen Kundinnen und Kunden einen auswaehlen koennen.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Angebotsbedingungen festlegen',
      qualifying_criteria: {
        title: 'Aktionsartikel',
        description:
          'Waehlen Sie die Kategorie aus, aus der Kundinnen und Kunden waehlen muessen, um den Gratisartikel zu erhalten.',
      },
      details: {
        title: 'Gratisartikel',
        description:
          'Kundinnen und Kunden koennen ihren zweiten Artikel aus den ausgewaehlten Aktionsartikeln waehlen. Der guenstigere Artikel wird gratis.',
      },
    },
  },
};
